module.exports = __webpack_public_path__ + "static/media/Monday_Step1_Image15.4cdf1078.jpg";